import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import Button from '../../Button';
import useToast from '../../../hooks/useToast';
import { physicalLocationsService } from '../../../services/physicalLocations.service';
import { TitleHeader, FormContainer } from './styles';
import { PhysicalLocation } from '../../../interfaces/physicalLocations.interface';

interface ModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onSuccess: () => void;
  locations: PhysicalLocation[];
  initialParentId?: string;
}

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '500px',
    borderRadius: '8px',
    padding: '24px',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1000,
  },
};

const ModalCreateLocation: React.FC<ModalProps> = ({ isOpen, setIsOpen, onSuccess, initialParentId }) => {
  const { successToast, errorToast } = useToast();
  const [name, setName] = useState('');
  const [type, setType] = useState('archive');
  const [parent, setParent] = useState('');
  const [capacity, setCapacity] = useState('');
  const [flatLocations, setFlatLocations] = useState<PhysicalLocation[]>([]);

  useEffect(() => {
    if (isOpen) {
      setParent(initialParentId || '');
      setName('');
      setCapacity('');
      
      physicalLocationsService.getLocations().then(res => {
        setFlatLocations(res.data);
      }).catch(err => console.error(err));
    }
  }, [isOpen, initialParentId]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      await physicalLocationsService.createLocation({
        name,
        type,
        parent: parent || undefined,
        capacity: capacity ? Number(capacity) : undefined,
      });
      successToast('Localização criada com sucesso');
      setIsOpen(false);
      onSuccess();
    } catch (error: any) {
      errorToast(error?.response?.data?.message || 'Erro ao criar');
    }
  };

  const typeTranslations: Record<string, string> = {
    archive: 'Arquivo Central',
    zone: 'Zona',
    street: 'Rua/Corredor',
    bookshelf: 'Estante',
    face: 'Face',
    shelf: 'Prateleira',
    box: 'Caixa',
    folder: 'Pasta Física'
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={() => setIsOpen(false)} style={customStyles} ariaHideApp={false}>
      <TitleHeader>
        <h3>Criar Localização Física</h3>
        <button onClick={() => setIsOpen(false)} style={{ background: 'transparent', border: 'none', cursor: 'pointer', fontSize: '18px' }}>X</button>
      </TitleHeader>
      <FormContainer onSubmit={handleSubmit}>
        <div>
          <label>Nome</label>
          <input type="text" value={name} onChange={e => setName(e.target.value)} required />
        </div>
        <div>
          <label>Tipo</label>
          <select value={type} onChange={e => setType(e.target.value)} required>
            <option value="archive">Arquivo Central</option>
            <option value="zone">Zona</option>
            <option value="street">Rua/Corredor</option>
            <option value="bookshelf">Estante</option>
            <option value="face">Face</option>
            <option value="shelf">Prateleira</option>
            <option value="box">Caixa</option>
            <option value="folder">Pasta Física</option>
          </select>
        </div>
        <div>
          <label>Nível Superior</label>
          <select value={parent} onChange={e => setParent(e.target.value)} disabled={!!initialParentId}>
            <option value="">Nenhum (Raiz)</option>
            {flatLocations.map(loc => (
              <option key={loc._id} value={loc._id}>{loc.name} ({typeTranslations[loc.type] || loc.type})</option>
            ))}
          </select>
        </div>
        <div>
          <label>Capacidade (Qtd máxima)</label>
          <input type="number" value={capacity} onChange={e => setCapacity(e.target.value)} />
        </div>
        <Button type="submit" label="Salvar" color="primary" variantType="block" onClick={handleSubmit} />
      </FormContainer>
    </Modal>
  );
};

export default ModalCreateLocation;
